// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__GBT-L","disabled":"Pagination_disabled__bxKFG","pagination":"Pagination_pagination__qFPiG","active":"Pagination_active__KeYW2"};